import React from "react";
import { Link, useParams } from "react-router-dom";
import { postgradute } from "../../../data/programs";
import { PostgraduateDeploma } from "../../../data/programs";
import { phd } from "../../../data/programs";
import parse from "html-react-parser";
import _ from "lodash";
import SectionCollapse from "./sections";

const backet =
  "https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets";

const cover = backet + "/others/cover.jpeg";

const PostgradDetail = () => {
  let program;
  const { tag } = useParams();
  program = _.find(postgradute, ["tag", tag]);
  if (!program) {
    program = _.find(PostgraduateDeploma, ["tag", tag]);
  }
  if (!program) {
    program = _.find(phd, ["tag", tag]);
  }

  return (
    <div className="">
      <div className="relative w-full overflow-hidden">
        <img
          src={program?.img || cover}
          className="h-[320px] w-full object-cover sm:h-[420px] md:h-[480px]"
          alt=""
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#17140e]/95 via-[#17140e]/40 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 mx-auto max-w-6xl px-4 pb-10 sm:px-6">
          {program?.school && (
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.15em] text-[#5eb3d4]">
              {program.school}
            </p>
          )}
          <h1 className="max-w-4xl text-3xl font-bold text-white sm:text-4xl md:text-5xl">
            {program ? program.program : "Program not found"}
          </h1>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center bg-[#eef3f8] px-4 py-10 text-black sm:px-6">
        <div className="mb-6 flex w-full max-w-4xl flex-col overflow-hidden">
          {program &&
            program.detail.map((d) => (
              <SectionCollapse key={d.id} title={d.title} icon={d.icon}>
                {parse(d.desc)}
              </SectionCollapse>
            ))}
        </div>
        <div className="flex w-full max-w-4xl flex-wrap justify-start gap-3 pb-3">
          <a
            href="https://shaag.odoo.com/web-registration"
            className="bg-[#0863AA] px-6 py-3 text-lg font-semibold uppercase text-white transition hover:bg-[#0a4f86]"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apply now
          </a>
          <Link
            to="/academics/postgraduate/programs"
            className="border-2 border-[#0863AA] px-6 py-3 text-lg font-semibold text-[#0863AA] transition hover:bg-white"
          >
            All programs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PostgradDetail;
